<router-outlet></router-outlet>
<app-logout-modal (stayEmit)="reset()"></app-logout-modal>